import React from 'react'
import { IconButton, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import RxOrderContainer from "../../containers/RxOrder";

interface Props {
    meganetLensRxOrderId: number,
    onEdit: (meganetLensRxOrderId: number) => void,
    onDelete: (meganetLensRxOrderId: number) => void,
}

export default ((props) => {
    const rxOrderContainer = RxOrderContainer.useContainer();

    return (
        <Grid container
            direction='row'
            justify='space-evenly'
            alignItems='flex-end'>
            <Grid item>
                <IconButton aria-label="edit" disabled={(rxOrderContainer.isNewRow || rxOrderContainer.isEditing || rxOrderContainer.isDeleting) && props.meganetLensRxOrderId !== rxOrderContainer.selectedOrderId ? true : false} onClick={() => props.onEdit(props.meganetLensRxOrderId)}>
                    <EditIcon style={{ color: 'black' }} />
                </IconButton>
            </Grid>
            <Grid item>
                <IconButton color="primary" aria-label="delete" disabled={(rxOrderContainer.isNewRow || rxOrderContainer.isEditing || rxOrderContainer.isDeleting) && props.meganetLensRxOrderId !== rxOrderContainer.selectedOrderId ? true : false} onClick={() => props.onDelete(props.meganetLensRxOrderId)} >
                    <DeleteOutlineIcon style={{ color: 'black' }} />
                </IconButton>
            </Grid>
        </Grid>
    )
}) as React.FC<Props>;
